import React from 'react';
/* ICONS */
import PinDropOutlinedIcon from '@material-ui/icons/PinDropOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import PhoneOutlinedIcon from '@material-ui/icons/PhoneOutlined';

/* PROGRAM MODULES */
import Moodule1 from '../assets/images/program/module1.png';
import Moodule2 from '../assets/images/program/module2.png';
import Moodule3 from '../assets/images/program/module3.jpg';
import Moodule4 from '../assets/images/program/module4.jpg';
import Moodule5 from '../assets/images/program/module5.png';
import Moodule6 from '../assets/images/program/module6.png';
import Moodule7 from '../assets/images/program/module7.png';
import Moodule8 from '../assets/images/program/module8.png';

/* STAFF */
import Staff1 from '../assets/images/direction/egratacos3.jpg';
import Staff2 from '../assets/images/direction/ffigueras3.jpg';
import Staff3 from '../assets/images/direction/jmmartinez3.jpg';
import Staff4 from '../assets/images/direction/lenciso3.jpg';
import Staff5 from '../assets/images/direction/mbennasar3.jpg';

/* TEACHERS */
import Teacher1 from '../assets/images/teachers/ogomez2-card.jpg';
import Teacher2 from '../assets/images/teachers/eixarch2.jpg';
import Teacher3 from '../assets/images/teachers/miriam_perez2.jpg';
import Teacher4 from '../assets/images/teachers/joan_sabria2.jpg';
import Teacher5 from '../assets/images/teachers/mar_bennasar3.jpg';
import Teacher6 from '../assets/images/teachers/monica_cruz2.jpg';
import Teacher7 from '../assets/images/teachers/laura_nogue2.png';

/* OPINIONS */
import Opinion1 from '../assets/images/opinions/opinion1.png';

/* LEGAL POLICY */
import CookiesPolicyES from '../assets/pdf/es/cookiesPolicy.pdf';
import LegalWarningES from '../assets/pdf/es/legalWarning.pdf';
import PrivacyPolicyES from '../assets/pdf/es/privacyPolicy.pdf';
import TermsOfUseES from '../assets/pdf/es/termsOfUse.pdf';
import TermsAndConditionsES from '../assets/pdf/es/termsAndConditions.pdf';

import CookiesPolicyEN from '../assets/pdf/en/cookiesPolicy.pdf';
import LegalWarningEN from '../assets/pdf/en/legalWarning.pdf';
import PrivacyPolicyEN from '../assets/pdf/en/privacyPolicy.pdf';
import TermsOfUseEN from '../assets/pdf/en/termsOfUse.pdf';
import TermsAndConditionsEN from '../assets/pdf/en/termsAndConditions.pdf';

/* INSCRIPTIONS OFF */
// import ImageOff from '../assets/images/50off.png';

/* PROMOTIONS */
import ImagePromo from '../assets/images/imagePromo.png';

/* SOCIAL MEDIA */
import FacebookIcon from '../assets/icons/facebook.svg';
import InstagramIcon from '../assets/icons/instagram.svg';
import LinkedInIcon from '../assets/icons/linkedinn.svg';
import VimeoIcon from '../assets/icons/vimeo.svg';
import TwitterIcon from '../assets/icons/twitter.svg';

/* PAYMENT METHODS */
import Santander from '../assets/images/paymentMethods/sandanter.png';
import Express from '../assets/images/paymentMethods/americanExpress.png';
import Mastercard from '../assets/images/paymentMethods/mastercard.png';
import Maestro from '../assets/images/paymentMethods/maestro.png';
import Visa from '../assets/images/paymentMethods/visa.png';
import Electron from '../assets/images/paymentMethods/electron.png';
import Ces from '../assets/images/paymentMethods/ces.png';

export const programModules = [
	{
		image: Moodule1,
		module: 'general.program.modules.one.module',
		title: 'general.program.modules.one.title'
	},
	{
		image: Moodule2,
		module: 'general.program.modules.two.module',
		title: 'general.program.modules.two.title'
	},
	{
		image: Moodule3,
		module: 'general.program.modules.three.module',
		title: 'general.program.modules.three.title'
	},
	{
		image: Moodule4,
		module: 'general.program.modules.four.module',
		title: 'general.program.modules.four.title'
	},
	{
		image: Moodule5,
		module: 'general.program.modules.five.module',
		title: 'general.program.modules.five.title'
	},
	{
		image: Moodule6,
		module: 'general.program.modules.six.module',
		title: 'general.program.modules.six.title'
	},
	{
		image: Moodule7,
		module: 'general.program.modules.seven.module',
		title: 'general.program.modules.seven.title'
	},
	{
		image: Moodule8,
		module: 'general.program.modules.eight.module',
		title: 'general.program.modules.eight.title'
	}
];

export const directionStaff = [
	{
		image: Staff1,
		name: 'general.staff.directors.staff.one.name',
		label: 'general.staff.directors.staff.one.label',
		description: 'general.staff.directors.staff.one.description',
		linkedin: 'https://www.linkedin.com/in/eduard-gratac%C3%B3s-0683a768/'
	},
	{
		image: Staff2,
		name: 'general.staff.directors.staff.two.name',
		label: 'general.staff.directors.staff.two.label',
		description: 'general.staff.directors.staff.two.description',
		linkedin: 'https://www.linkedin.com/in/francesc-figueras-44182856/'
	},
	{
		image: Staff3,
		name: 'general.staff.directors.staff.three.name',
		label: 'general.staff.directors.staff.three.label',
		description: 'general.staff.directors.staff.three.description'
	},
	{
		image: Staff4,
		name: 'general.staff.directors.staff.four.name',
		label: 'general.staff.directors.staff.four.label',
		description: 'general.staff.directors.staff.four.description',
		linkedin: 'https://www.linkedin.com/in/luis-enciso-25889168/'
	},
	{
		image: Staff5,
		name: 'general.staff.directors.staff.five.name',
		label: 'general.staff.directors.staff.five.label',
		description: 'general.staff.directors.staff.five.description',
		linkedin: 'https://www.linkedin.com/in/mar-bennasar-09016670/'
	}
];

export const teacherStaff = [
	{
		name: 'general.staff.teachers.staff.one.name',
		label: 'general.program.modules.five.module',
		descriptions: ['general.program.modules.five.title'],
		image: Teacher1,
		imagePosition: 'center center'
	},
	{
		name: 'general.staff.teachers.staff.two.name',
		label: 'general.program.modules.two.module',
		descriptions: ['general.program.modules.two.title'],
		image: Teacher2,
		imagePosition: 'center -70px'
	},
	{
		name: 'general.staff.teachers.staff.three.name',
		label: 'general.program.modules.seven.module',
		descriptions: ['general.program.modules.seven.title'],
		image: Teacher3,
		imagePosition: 'center -88px'
	},
	{
		name: 'general.staff.teachers.staff.four.name',
		label: 'general.program.modules.eight.module',
		descriptions: ['general.program.modules.eight.title'],
		image: Teacher4,
		imagePosition: 'center -80px'
	},
	{
		name: 'general.staff.teachers.staff.five.name',
		label: 'general.staff.teachers.staff.five.label',
		descriptions: [
			'general.program.modules.one.title',
			'general.program.modules.three.title',
			'general.program.modules.four.title',
			'general.program.modules.six.title'
		],
		image: Teacher5,
		imagePosition: 'center -50px'
	},
	{
		name: 'general.staff.teachers.staff.six.name',
		label: 'general.staff.teachers.staff.six.label',
		descriptions: ['general.staff.teachers.staff.six.description'],
		image: Teacher6,
		imagePosition: 'center -12px'
	},
	{
		name: 'general.staff.teachers.staff.seven.name',
		label: 'general.staff.teachers.staff.seven.label',
		descriptions: ['general.staff.teachers.staff.seven.description'],
		image: Teacher7,
		imagePosition: 'center -90px'
	}
];

export const categories = [
	{ title: 'general.opinions.categories.one', limit: 90 },
	{ title: 'general.opinions.categories.two', limit: 70 },
	{ title: 'general.opinions.categories.three', limit: 100 },
	{ title: 'general.opinions.categories.four', limit: 85 }
];

export const icons = [
	{
		title: 'general.icons.location.title',
		description: 'general.icons.location.description',
		detail: 'general.icons.location.detail',
		image: <PinDropOutlinedIcon />
	},
	{
		title: 'general.icons.telephone.title',
		image: <PhoneOutlinedIcon />
	},
	{
		title: 'general.icons.email.title',
		image: <EmailOutlinedIcon />
	}
];

export const opinions = [1, 2, 3, 4, 5].map((item, idx) => ({
	image: Opinion1,
	description: `general.opinions.data.${item}.description`,
	name: `general.opinions.data.${item}.name`,
	profession: `general.opinions.data.${item}.profession`
}));

const FullCourse = {
	tag: '',
	tagColor: 'transparent',
	label: 'general.prices.one.label',
	title: 'general.prices.one.title',
	subtitle: 'general.prices.one.subtitle',
	price: {
		lastValue: 'general.prices.one.price.lastValue',
		value: 'general.prices.one.price.value',
		promotion: 'general.prices.one.price.promotion',
		description: 'general.prices.one.price.description'
	},
	information: {
		primary: []
	},
	image: ImagePromo,
	labelWhite: true,
	discount: {
		text: 'general.prices.one.discount.text',
		button: 'general.prices.one.discount.button',
		linkES: 'https://forms.gle/1B956n7vSMpReWud9',
		linkEN:
			'https://docs.google.com/forms/d/e/1FAIpQLScJDExbHyGwJXJOWrHBlVcsihSAF13sA2j3PUotPe70Eb1hxQ/viewform'
	},
	buttonDisabled: true
};

const Module1 = {
	tag: 'general.prices.two.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.two.label',
	title: 'general.program.modules.one.title',
	subtitle: 'general.prices.two.subtitle',
	price: {
		lastValue: 'general.prices.two.price.lastValue',
		value: 'general.prices.two.price.value',
		promotion: 'general.prices.two.price.promotion',
		description: 'general.prices.two.price.description'
	},
	information: {
		primary: ['general.prices.two.information.primary.one']
	},
	image: Moodule1,
	buttonDisabled: true
};
const Module2 = {
	tag: 'general.prices.three.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.three.label',
	title: 'general.program.modules.two.title',
	subtitle: 'general.prices.three.subtitle',
	price: {
		lastValue: 'general.prices.three.price.lastValue',
		value: 'general.prices.three.price.value',
		promotion: 'general.prices.three.price.promotion',
		description: 'general.prices.three.price.description'
	},
	information: {
		primary: ['general.prices.three.information.primary.one']
	},
	image: Moodule2,
	buttonDisabled: true
};

const Module3 = {
	tag: 'general.prices.four.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.four.label',
	title: 'general.program.modules.three.title',
	subtitle: 'general.prices.four.subtitle',
	price: {
		lastValue: 'general.prices.four.price.lastValue',
		value: 'general.prices.four.price.value',
		promotion: 'general.prices.four.price.promotion',
		description: 'general.prices.four.price.description'
	},
	information: {
		primary: ['general.prices.four.information.primary.one']
	},
	image: Moodule3,
	buttonDisabled: true
};
const Module4 = {
	tag: 'general.prices.five.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.five.label',
	title: 'general.program.modules.four.title',
	subtitle: 'general.prices.five.subtitle',
	price: {
		lastValue: 'general.prices.five.price.lastValue',
		value: 'general.prices.five.price.value',
		promotion: 'general.prices.five.price.promotion',
		description: 'general.prices.five.price.description'
	},
	information: {
		primary: ['general.prices.five.information.primary.one']
	},
	image: Moodule4,
	buttonDisabled: true
};

const Module5 = {
	tag: 'general.prices.six.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.six.label',
	title: 'general.program.modules.five.title',
	subtitle: 'general.prices.six.subtitle',
	price: {
		lastValue: 'general.prices.six.price.lastValue',
		value: 'general.prices.six.price.value',
		promotion: 'general.prices.six.price.promotion',
		description: 'general.prices.six.price.description'
	},
	information: {
		primary: ['general.prices.six.information.primary.one']
	},
	image: Moodule5,
	buttonDisabled: false
};
const Module6 = {
	tag: 'general.prices.seven.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.seven.label',
	title: 'general.program.modules.six.title',
	subtitle: 'general.prices.seven.subtitle',
	price: {
		lastValue: 'general.prices.seven.price.lastValue',
		value: 'general.prices.seven.price.value',
		promotion: 'general.prices.seven.price.promotion',
		description: 'general.prices.seven.price.description'
	},
	information: {
		primary: ['general.prices.seven.information.primary.one']
	},
	image: Moodule6,
	buttonDisabled: true
};

const Module7 = {
	tag: 'general.prices.eight.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.eight.label',
	title: 'general.program.modules.seven.title',
	subtitle: 'general.prices.eight.subtitle',
	price: {
		lastValue: 'general.prices.eight.price.lastValue',
		value: 'general.prices.eight.price.value',
		promotion: 'general.prices.eight.price.promotion',
		description: 'general.prices.eight.price.description'
	},
	information: {
		primary: ['general.prices.eight.information.primary.one']
	},
	image: Moodule7,
	buttonDisabled: true
};
const Module8 = {
	tag: 'general.prices.nine.tag',
	tagColor: '#b4b3b3',
	label: 'general.prices.nine.label',
	title: 'general.program.modules.eight.title',
	subtitle: 'general.prices.nine.subtitle',
	price: {
		lastValue: 'general.prices.nine.price.lastValue',
		value: 'general.prices.nine.price.value',
		promotion: 'general.prices.nine.price.promotion',
		description: 'general.prices.nine.price.description'
	},
	information: {
		primary: ['general.prices.nine.information.primary.one']
	},
	image: Moodule8,
	buttonDisabled: true
};

const ModuleSortEN = [
	Module5,
	FullCourse,
	Module1,
	Module2,
	Module3,
	Module4,
	Module6,
	Module7,
	Module8
];
const ModuleSortES = [
	FullCourse,
	Module1,
	Module2,
	Module3,
	Module4,
	Module5,
	Module6,
	Module7,
	Module8
];

export const prices = {
	es: ModuleSortES,
	en: ModuleSortEN
};

export const policies = [
	{
		title: 'legalWarning.legalWarning',
		pdfES: LegalWarningES,
		pdfEN: LegalWarningEN
	},
	{
		title: 'legalWarning.termsOfUse',
		pdfES: TermsOfUseES,
		pdfEN: TermsOfUseEN
	},
	{
		title: 'legalWarning.privacyPolicy',
		pdfES: PrivacyPolicyES,
		pdfEN: PrivacyPolicyEN
	},
	{
		title: 'legalWarning.cookiesPolicy',
		pdfES: CookiesPolicyES,
		pdfEN: CookiesPolicyEN
	},
	{
		title: 'legalWarning.termsAndConditions',
		pdfES: TermsAndConditionsES,
		pdfEN: TermsAndConditionsEN
	}
];

export const social_media = [
	{
		link: 'https://twitter.com/medfetalBCN',
		icon: TwitterIcon
	},
	{
		link: 'https://www.instagram.com/medicinafetalbarcelona	',
		icon: InstagramIcon
	},
	{
		link: 'https://www.facebook.com/Medicinafetalbarcelona/',
		icon: FacebookIcon
	},
	{
		link: 'https://www.linkedin.com/company/9245603/admin/',
		icon: LinkedInIcon
	},
	{
		link: 'https://vimeo.com/medicinamaternofetal',
		icon: VimeoIcon
	}
];

export const paymentMethods = [
	Santander,
	Express,
	Mastercard,
	Maestro,
	Visa,
	Electron,
	Ces
];

export const SIGN_UP_CURSE = '/cursos/users/sign_up';

export const SIGN_IN = '/cursos/users/sign_in';

export const PRESENTATION = '/cursos/course_one/theme_example';
